export default class StyleHelper {

    public static resetCssAnimations() {
        (<any>window).addEventListener("load", function () {
            let loaders = document.getElementsByClassName("loader");
            for (let i = 0; i < loaders.length; i++) {
                loaders[i].classList.add("hide");
            }

            document.querySelectorAll(".loader-box").forEach(item => {
                item.classList.add("hide");
            });

            document.querySelectorAll(".search-criteria, .search-options").forEach(item => {
                item.classList.remove("hden");
            });
        });
    }
}